// extracted by mini-css-extract-plugin
module.exports = {"table":"buy-fuel_table__TGlMd"};